import ImagesearchRollerRoundedIcon from '@mui/icons-material/ImagesearchRollerRounded'
import { Box, Stack } from '@mui/material'
import { DeepcellDrawer } from 'components/shared/drawer'
import _ from 'lodash'
import { useState } from 'react'
import { useCellVisualizationsSlice } from 'redux/slices/hooks/useCellVisualizationsSlice'
import { DENSITY_ATTRIBUTE } from 'utils/constants'
import { ColorByDropdown } from './ColorByDropdown'
import FiltersApplied from './FiltersApplied'
import { FiltersAppliedDetails } from './FiltersAppliedDetails'
import { ToggleVisibilityButton } from './ToggleVisibilityButton'
import Legend from './Legend'

export const colorByButtonId = 'colorByButtonId'

const RollerIcon = () => <ImagesearchRollerRoundedIcon sx={{ ml: 1 }} />

export const ColorByDrawer = ({
  showPreFilter = false,
  forceCollapsed = false,
}: {
  showPreFilter?: boolean
  forceCollapsed?: boolean
}): JSX.Element => {
  const [showFiltersAppliedDetails, setShowFiltersAppliedDetails] = useState(false)

  const {
    setShowColorBy,
    cellVisualizations: { showColorBy, plotDisplayType },
    hiddenCellInfoGroupValues,
    selectedCellInfoGroup: { isContinuous, category },
  } = useCellVisualizationsSlice()
  const isDensity = plotDisplayType === DENSITY_ATTRIBUTE
  const showToggle = !isContinuous && category
  const showFilter = showToggle && _.keys(hiddenCellInfoGroupValues).length > 0
  let headerText
  if (showPreFilter === true) {
    headerText = 'Color By'
  } else if (isDensity) {
    headerText = 'Filter By'
  } else {
    headerText = 'Filter / Color By'
  }

  // When forceCollapsed is true, show minimal button but still allow opening
  const isOpen = showColorBy

  return (
    <DeepcellDrawer
      buttonText={headerText}
      floatingButtonProps={{
        id: colorByButtonId,
        startIcon: forceCollapsed ? undefined : <RollerIcon />,
        sx: forceCollapsed
          ? {
              minWidth: 'auto',
              padding: '6px 12px',
              '& .MuiButton-startIcon': { margin: 0 },
              fontSize: 0,
            }
          : undefined,
      }}
      drawerButtonProps={{
        startIcon: <RollerIcon />,
      }}
      onResolve={(drawerOpen) => setShowColorBy(drawerOpen)}
      open={isOpen}
    >
      {showFiltersAppliedDetails ? (
        <FiltersAppliedDetails onBackClick={() => setShowFiltersAppliedDetails(false)} />
      ) : (
        <Stack spacing={2}>
          <ColorByDropdown showPreFilter={showPreFilter} />
          {showFilter ? (
            <FiltersApplied onDetailsClick={() => setShowFiltersAppliedDetails(true)} />
          ) : null}
          <Box sx={{ height: '4px', alignSelf: 'end' }}>
            {showToggle && !showPreFilter ? <ToggleVisibilityButton /> : null}
          </Box>
          {category || (isDensity && showPreFilter) ? (
            <Legend showPreFilter={showPreFilter} />
          ) : null}
        </Stack>
      )}
    </DeepcellDrawer>
  )
}

export default ColorByDrawer
